<ng-container [ngSwitch]="menuContentService.typeObserver | async">
  <app-options-user-menu *ngSwitchCase="MenuMobileTypes.MENU_USER"></app-options-user-menu>
  <app-options-country-menu *ngSwitchCase="MenuMobileTypes.MENU_COUNTRY"></app-options-country-menu>
  <app-options-navigation-menu *ngSwitchCase="MenuMobileTypes.MENU_NAVIGATOR"></app-options-navigation-menu>
</ng-container>
